'use client';

import { useAnalytics } from '@cc-shopping/platform-analytics/hooks/useAnalytics';
import { EventName } from '@cc-shopping/platform-analytics/Shibuya';
import Box from '@mui/material/Box';
import type React from 'react';
import { useRef } from 'react';
import { v4 as uuid } from 'uuid';

export type ExpandCardProps = {
  children: React.ReactNode;
  title2?: string;
};

export function ExpandCardClient({ children, title2 }: ExpandCardProps) {
  const eventId = useRef<string>(uuid());
  const { analytics } = useAnalytics();

  const trackToggle = (event: React.MouseEvent<HTMLDetailsElement>) => {
    const isOpen = event.currentTarget.open;
    analytics.track(EventName.FEATURE_INTERACTED, {
      eventName: 'feature_interacted',
      attributes: {
        entity_name: 'NWVerifiedContainer',
        section_name: 'tile',
        interaction_type: isOpen ? 'hide_info' : 'show_info',
        item_copy: title2,
        parent_event_id: eventId.current,
        additional_attributes: {
          action_name: isOpen ? 'hide_info' : 'show_info',
        },
      },
    });
  };

  return (
    <Box
      component="details"
      onClick={trackToggle}
      sx={{
        borderRadius: '8px',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        justifyContent: 'center',
        border: '1px solid',
        borderColor: 'transparent',
        transition: 'border-color 0.3s ease',
        WebkitTapHighlightColor: 'transparent',
        '&:hover': {
          borderColor: 'greens.main',
          cursor: 'pointer',
        },
      }}
    >
      {children}
    </Box>
  );
}
